import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import useTranslations from "../useTranslations";
import * as styles from "./career.module.css";

const CarerrBox = (props) => {
  const { translate, site } = useStaticQuery(query);
  const { apply } = useTranslations(translate);

  return (
    <div className="container-fluid mb-5">
      <div className="row">
        <div className={`columns col-lg-7 col-lx-7 col-12 ${styles.formulage}`}>
          <h2 className={`f-light text-center`}>{apply}</h2>
          <div className={styles.work__form}>
            <h1 className={styles.work__email}>{site.siteMetadata.email}</h1>
          </div>
        </div>
        <div
          className={`columns col-lg-5 col-lx-5 col-12 ${styles.work_description}`}
        >
          <div className={styles.work_box}>{props?.children}</div>
        </div>
      </div>
    </div>
  );
};

export default CarerrBox;

const query = graphql`
  query CarerrBox {
    translate: allFile(filter: { sourceInstanceName: { eq: "translations" } }) {
      edges {
        node {
          name
          translations: childTranslationsJson {
            apply
          }
        }
      }
    }
    site {
      siteMetadata {
        email
      }
    }
  }
`;
